const prod = {
  url: {
    FAC_URL: "https://api.che.apcfss.in/collegenoc/",
    FILE_DOWNLOAD_URL: "https://api.apfd.apcfss.in/socialwelfaredms/user-defined-path/file-download/bucket/affiliation-documents/",
    FILE_UPLOAD_URL: 'https://api.apfd.apcfss.in/socialwelfaredms/user-defined-path/file-upload/bucket/affiliation-documents/affiliation/',

  },


};
const protocol = window.location.protocol === "https:" ? "https" : "http";
const dev = {
  url: {
    FAC_URL: "https://swapi.dev.nidhi.apcfss.in/collegenoc/", //DEV
    FILE_DOWNLOAD_URL: "https://swapi.dev.nidhi.apcfss.in/socialwelfaredms/user-defined-path/file-download/",
    FILE_UPLOAD_URL: `https://swapi.dev.nidhi.apcfss.in/socialwelfaredms/user-defined-path/file-upload/affiliation/`,
  },
};

const local = {
  url: {

    FAC_URL: "https://swapi.dev.nidhi.apcfss.in/collegenoc/", //DEV
    // FAC_URL: "http://172.16.119.243:8000/collegenoc/",
    // FAC_URL: "http://172.16.118.44:8000/collegenoc/",
    // FAC_URL: "http://172.16.119.131:8000/collegenoc/",

    FILE_UPLOAD_URL: `https://swapi.dev.nidhi.apcfss.in/socialwelfaredms/user-defined-path/file-upload/affiliation/`,
    FILE_DOWNLOAD_URL: `https://swapi.dev.nidhi.apcfss.in/socialwelfaredms/user-defined-path/file-download/`,
  },
};

export const config = process.env.NODE_ENV === "development" ? dev : prod;


